import React from "react";
import ReactApexChart from "react-apexcharts";

const BurgerChart = () => {
  const chartOptions = {
    chart: {
      type: "radialBar",
      offsetY: -20,
    },
    series: [905.41, 17.87, 73.12, 13.48, 2.5, 154.56, 212.34], // Data for each section (in Crores)
    labels: [
      "Total Budget",
      "Audit",
      "Installation",
      "Delivery",
      "Reco",
      "Frame Production",
      "Manufacturing",
    ],
    plotOptions: {
      radialBar: {
        distributed: true,
        dataLabels: {
          name: {
            fontSize: "16px",
            fontWeight: "semi-bold",
            color: "#333",
          },
          value: {
            fontSize: "14px",
            fontWeight: "bold",
            color: "#333",
          },
        },
      },
    },
    colors: [
      "#418CFF",
      "#4caf50",
      "#ff9800",
      "#ff5722",
      "#9c27b0",
      "#03a9f4",
      "#00bcd4",
    ],
    stroke: {
      lineCap: "round",
    },
    legend: {
      position: "bottom",
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            width: "100%",
          },
        },
      },
    ],
  };

  return (
    <div style={{ maxWidth: "100%", padding: "1rem", paddingTop: "0rem" }}>
      <h3
        style={{
          textAlign: "center",
          marginBottom: "1rem",
          fontSize: "21px",
          fontWeight: "700",
          paddingTop: "10px",
        }}
      >
        BUDGET BREAKDOWN
      </h3>

      <ReactApexChart
        options={chartOptions}
        series={chartOptions.series}
        type="radialBar"
        height={350}
      />
    </div>
  );
};

export default BurgerChart;
